import MicroModal from 'micromodal';
import Glide, { Controls, Images } from '@glidejs/glide/dist/glide.modular.esm';

class ImageGallery {

    constructor(root) {
        this.root = root;
        this.slider = null;

        MicroModal.init({
            debugMode: true,
            onShow: () => {
                this.slider = new Glide(this.root, {
                    perView: 1,
                    autoplay: 4000
                }).mount({ Controls, Images });
            }
        });

    }
}

const cottageGallery = document.querySelector('.cottage-glide');

if (cottageGallery) {
    window.cottageGallery = new ImageGallery(cottageGallery);
}

export default ImageGallery;